// PARA-136 — клиентская валидация формы настроек вечернего напоминания.

const TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;

/** Проверка строки времени в формате HH:MM. */
export function validateTime(value: string): string | null {
  if (!value) {
    return 'validation.timeRequired';
  }
  if (!TIME_PATTERN.test(value)) {
    return 'validation.timeInvalid';
  }
  return null;
}

let _supportedTimezones: readonly string[] | undefined;

/** Ленивое кэширование списка IANA-зон. */
function getSupportedTimezones(): readonly string[] {
  if (_supportedTimezones === undefined) {
    try {
      _supportedTimezones =
        (Intl as unknown as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf?.(
          'timeZone',
        ) ?? [];
    } catch {
      _supportedTimezones = [];
    }
  }
  return _supportedTimezones;
}

/** Проверка IANA-часового пояса. */
export function validateTimezone(value: string): string | null {
  if (!value) {
    return 'validation.timezoneRequired';
  }
  const supported = getSupportedTimezones();
  if (supported.length > 0 && !supported.includes(value)) {
    return 'validation.timezoneInvalid';
  }
  // Fallback для окружений без Intl.supportedValuesOf: пробуем сконструровать.
  try {
    Intl.DateTimeFormat(undefined, { timeZone: value });
    return null;
  } catch {
    return 'validation.timezoneInvalid';
  }
}
